exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-detail[data-v-6af81025]{background:#fff}.content-detail .detail-header[data-v-6af81025]{margin-bottom:20px}.content-detail .service-label-group[data-v-6af81025]{font-size:12px;color:#999;margin-bottom:10px}.content-detail .service-label-group span[data-v-6af81025]{margin-right:10px}.content-detail .service-label-group span .ico[data-v-6af81025]{-webkit-transform:scale(.8);transform:scale(.8);display:inline-block;margin-right:5px}", ""]);

// exports
